import { gql } from "@/gql/__generated__";
import { UserMembershipsQuery } from "@/gql/__generated__/graphql";
import { useMutation } from "@apollo/client";
import { GET_USER_MEMBERSHIPS } from "../user/getUserMemberships";

const ORGANIZATION_CREATE = gql(`
  mutation ORGANIZATION_CREATE($name: String!, $whiteLabelDomain: String) {
    organizationCreate(input: { name: $name, whiteLabelDomain: $whiteLabelDomain }) {
      __typename
      ... on Organization{
        id
        name
        slug
        createdAt
        members {
          __typename
          id
          role
          user { id }
        }
      }
    }
  }
`);

export const useOrganizationCreate = () => {
  const mutation = useMutation(ORGANIZATION_CREATE, {
    update(cache, { data }) {
      if (!data) return;
      const newOrganization = data.organizationCreate;

      if (newOrganization.__typename !== "Organization") {
        return;
      }

      cache.updateQuery({ query: GET_USER_MEMBERSHIPS }, (cacheData) => {
        if (!cacheData) return undefined;

        const membership = newOrganization.members.find(
          ({ user }) => user.id === cacheData.me.id
        );
        if (!membership) return undefined;

        const updatedOrganizationList: UserMembershipsQuery = {
          __typename: "Query",
          me: {
            __typename: "User",
            id: cacheData.me.id,
            memberships: [
              ...cacheData.me.memberships,
              {
                ...membership,
                organization: newOrganization
              }
            ]
          }
        };

        return updatedOrganizationList;
      });
    }
  });
  return mutation;
};
